import { Box, Heading, Text, VStack } from "@chakra-ui/react";

export default function PrivacyPolicyPage() {
  return (
    <Box maxW="800px" mx="auto" p={6}>
      <Heading as="h1" mb={4}>
        Privacy Policy
      </Heading>
      {/* <Text fontSize="sm" color="gray.500" mb={4}> */}
      {/*   Last updated: [Insert Date] */}
      {/* </Text> */}
      <VStack align="start" spacing={4}>
        <Text>
          At SL Teach (“we”, “our”, “us”), we respect your privacy and are
          committed to protecting your personal data. This Privacy Policy
          explains how we collect, use, and safeguard your information when you
          use our learning management system (“Platform”).
        </Text>

        <Heading as="h2" size="md">
          1. Information We Collect
        </Heading>
        <Text>
          We collect the following types of data when you interact with our
          Platform:
          <br />
          <br />
          <strong>Account Information</strong>
          <br />
          - Name
          <br />
          - Email address
          <br />
          - Password (encrypted)
          <br />
          <br />
          <strong>Payment Information</strong>
          <br />
          - Transaction details (amount, date, payment method)
          <br />
          We do not store your full card or bank details — payments are securely
          processed by the Commercial Bank Payment Gateway.
          <br />
          <br />
          <strong>Usage Information</strong>
          <br />
          - Pages you visit
          <br />
          - Class recordings and materials you access
          <br />
          - Interaction timestamps
          <br />
          <br />
          <strong>Technical Data</strong>
          <br />
          - IP address
          <br />
          - Browser type
          <br />- Device type
        </Text>

        <Heading as="h2" size="md">
          2. How We Use Your Information
        </Heading>
        <Text>
          We use your data to:
          <br />
          - Create and manage your account.
          <br />
          - Provide access to class recordings and question papers.
          <br />
          - Process payments securely.
          <br />
          - Send you important notifications about your account or payments.
          <br />
          - Improve our Platform performance and user experience.
          <br />- Comply with legal and financial obligations.
        </Text>

        <Heading as="h2" size="md">
          3. Sharing Your Information
        </Heading>
        <Text>
          We do not sell or rent your personal data.
          <br />
          We may share your information with:
          <br />
          - Payment processors (Commercial Bank) for secure payment handling.
          <br />
          - Service providers who help us operate the Platform (e.g., hosting,
          security).
          <br />- Authorities if required by law, regulation, or legal process.
        </Text>

        <Heading as="h2" size="md">
          4. Data Security
        </Heading>
        <Text>
          We implement appropriate technical and organizational measures to
          protect your personal data. However, no online system is 100% secure,
          and we cannot guarantee absolute security.
        </Text>

        <Heading as="h2" size="md">
          5. Data Retention
        </Heading>
        <Text>
          We retain your personal data as long as your account is active and for
          as long as necessary to fulfill our legal obligations, resolve
          disputes, and enforce our policies.
        </Text>

        <Heading as="h2" size="md">
          6. Your Rights
        </Heading>
        <Text>
          Depending on your location, you may have rights under applicable data
          protection laws, including:
          <br />
          - Accessing the personal data we hold about you.
          <br />
          - Requesting correction or deletion of your data.
          <br />
          - Objecting to certain uses of your data.
          <br />
          - Withdrawing consent (where applicable).
          <br />
          To exercise your rights, contact us at the details below.
        </Text>

        <Heading as="h2" size="md">
          7. Cookies and Tracking
        </Heading>
        <Text>
          We may use cookies or similar technologies to:
          <br />
          - Maintain your session.
          <br />
          - Analyze usage for Platform improvement.
          <br />
          You can adjust your browser settings to reject cookies, but this may
          affect your experience.
        </Text>

        <Heading as="h2" size="md">
          8. International Transfers
        </Heading>
        <Text>
          If you access the Platform from outside our main operating region,
          your data may be processed in countries that may not have the same
          data protection laws as your country. We take steps to ensure adequate
          protection for such transfers.
        </Text>

        <Heading as="h2" size="md">
          9. Changes to This Policy
        </Heading>
        <Text>
          We may update this Privacy Policy from time to time. We will notify
          you of major changes by email or through the Platform.
        </Text>

        {/* <Heading as="h2" size="md"> */}
        {/*   10. Contact Us */}
        {/* </Heading> */}
        {/* <Text> */}
        {/*   If you have questions about this Privacy Policy or wish to exercise */}
        {/*   your data rights, contact us at: */}
        {/*   <br /> */}
        {/*   Email: [Insert contact email] */}
        {/*   <br /> */}
        {/*   Phone: [Insert contact number] */}
        {/* </Text> */}
      </VStack>
    </Box>
  );
}
